import React from 'react'

const StatsCard = ({
  title,
  content
}) => {
  return (
    <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 p-4 rounded-lg shadow-sm">
      <p className="text-sm text-green-700 font-medium">{title}</p>
      <p className="text-2xl font-bold text-green-800">{content}</p>
    </div>
  );
}

export default StatsCard;